import { connect } from "react-redux";
import ZoneListing from "../InfraZoneListing/Listing";
import { bindActionCreators } from "redux";
import { getZoneList } from "services/redux/Valet/InfraZone/action";

const mapStateToProps = (state) => ({
    zoneList : state.CreateInfraZoneReducer.zoneList,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({
        getZoneList
    }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(ZoneListing);